(function () {
  'use strict';

  if (window.gmlInquiryInstalled) return;
  window.gmlInquiryInstalled = true;

  var inquiryMessages = {};
  var inquirySource = document.querySelector('[data-gml-inquiry-messages]');
  try { inquiryMessages = JSON.parse(inquirySource ? inquirySource.textContent : '{}'); } catch (error) { inquiryMessages = {}; }
  function inquiryText(key, fallback) {
    return typeof inquiryMessages[key] === 'string' ? inquiryMessages[key] : fallback;
  }

  var controllers = new Map();
  var countryLabels;
  try { countryLabels = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'region' }); } catch (error) {}

  function normalizeCountry(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  function filterCountries(countries, query) {
    var prefix = normalizeCountry(query);

    return countries.filter(function (country) {
      return [country.name, country.value, country.code].some(function (value) { return normalizeCountry(value).indexOf(prefix) === 0; });
    });
  }

  function parsePhone(raw, countryCode) {
    var value = String(raw || '').trim();

    if (!value) {
      return { error: inquiryText('phone_required', 'Please enter your phone number.') };
    }

    if (!/^\+?[0-9 ().\-]+$/.test(value)) {
      return {
        error:
          inquiryText('phone_characters', 'Use digits only, with optional +, spaces, brackets or hyphens. Letters are not allowed.')
      };
    }

    var digits = value.replace(/\D/g, '');
    var international = value.charAt(0) === '+';
    var northAmerica = countryCode === 'CA' || countryCode === 'US';

    if (digits.length < 7 || digits.length > 15) {
      return {
        error: inquiryText('phone_length', 'Please enter a phone number containing 7 to 15 digits.')
      };
    }

    if (international && digits.charAt(0) === '0') {
      return {
        error:
          inquiryText('phone_leading_zero', 'After +, enter your country calling code without a leading zero.')
      };
    }

    var isNanp =
      (international && digits.charAt(0) === '1') ||
      (!international && northAmerica);

    if (isNanp) {
      var hasCountryCode =
        digits.length === 11 && digits.charAt(0) === '1';

      var local = hasCountryCode ? digits.slice(1) : digits;

      if (
        (international && !hasCountryCode) ||
        !/^[2-9][0-9]{2}[2-9][0-9]{6}$/.test(local)
      ) {
        return {
          error:
            inquiryText('phone_north_america', 'Enter a 10-digit Canada/US number, optionally preceded by 1 or +1.')
        };
      }

      return {
        value:
          '+1 (' +
          local.slice(0, 3) +
          ') ' +
          local.slice(3, 6) +
          '-' +
          local.slice(6),
        dial: '+1' + local
      };
    }

    if (!international) {
      return {
        error:
          inquiryText('phone_international', 'Include + and the country calling code before your phone number.')
      };
    }

    return {
      value: value.replace(/\s+/g, ' '),
      dial: '+' + digits
    };
  }

  function contactActionURL(base, number) {
    if (!/^\+[1-9][0-9]{6,14}$/.test(number)) return '';

    var url = new URL(base);

    if (url.protocol !== 'https:' && url.protocol !== 'http:') {
      return '';
    }

    url.search = '';
    url.hash = 'gml-contact=' + encodeURIComponent(number);

    return url.href;
  }

  function numberFromHash(hash) {
    var match = /^#gml-contact=(.*)$/.exec(hash);

    if (!match) return '';

    try {
      var number = decodeURIComponent(match[1]);

      return /^\+[1-9][0-9]{6,14}$/.test(number) ? number : '';
    } catch (error) {
      return '';
    }
  }

  function showContactActions() {
    var number = numberFromHash(window.location.hash);

    if (!number || document.getElementById('GmlContactActions')) {
      return;
    }

    var dialog = document.createElement('dialog');
    dialog.id = 'GmlContactActions';
    dialog.setAttribute('aria-labelledby', 'GmlContactActionsTitle');

    var style = document.createElement('style');

    style.textContent = `
      #GmlContactActions {
        box-sizing: border-box;
        width: min(420px, calc(100% - 32px));
        max-height: calc(100dvh - 32px);
        overflow: auto;
        margin: auto;
        padding: 32px;
        border: 1px solid #e5e2dc;
        background: #ffffff;
        color: #171717;
        border-radius: 12px;
        text-align: center;
        font: 16px/1.5 Arial, sans-serif;
        box-shadow: 0 20px 80px #0003;
      }

      #GmlContactActions::backdrop {
        background: rgba(0, 0, 0, 0.45);
      }

      #GmlContactActions .gml-contact-brand {
        margin: 0 0 24px;
        font: bold 32px Georgia, serif;
      }

      #GmlContactActions h2 {
        margin: 0 0 12px;
        font: 22px/1.3 Georgia, serif;
      }

      #GmlContactActions .gml-contact-number {
        display: block;
        margin: 0 0 24px;
        color: #171717;
        font-size: 20px;
        text-decoration: underline;
        overflow-wrap: anywhere;
      }

      #GmlContactActions .gml-contact-buttons {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
      }

      #GmlContactActions .gml-contact-buttons a {
        display: block;
        padding: 12px 8px;
        border: 1px solid #171717;
        border-radius: 6px;
        text-decoration: none;
        color: #ffffff;
        background: #171717;
        font: inherit;
      }

      #GmlContactActions .gml-contact-buttons a:last-child {
        color: #171717;
        background: #ffffff;
      }

      #GmlContactActions button {
        margin-top: 24px;
        padding: 8px 16px;
        border: 0;
        background: transparent;
        color: #555555;
        text-decoration: underline;
        font: inherit;
        cursor: pointer;
      }

      #GmlContactActions :focus-visible {
        outline: 2px solid #171717;
        outline-offset: 4px;
      }
    `;

    document.head.appendChild(style);

    function element(tag, text, className) {
      var node = document.createElement(tag);
      node.textContent = text;

      if (className) node.className = className;

      return node;
    }

    var title = element('h2', inquiryText('contact_customer', 'Contact customer'));
    title.id = 'GmlContactActionsTitle';

    var formatted = parsePhone(number, '');

    var numberLink = element(
      'a',
      formatted.value || number,
      'gml-contact-number'
    );

    numberLink.href = 'tel:' + number;

    var buttons = element('div', '', 'gml-contact-buttons');

    var call = element('a', inquiryText('call', 'Call'));
    call.href = 'tel:' + number;

    var text = element('a', inquiryText('sms', 'Text message'));
    text.href = 'sms:' + number;

    buttons.append(call, text);

    var close = element('button', inquiryText('close_watch', 'Close / view watch'));
    close.type = 'button';

    dialog.append(
      element('p', inquiryText('brand', 'gmltime.'), 'gml-contact-brand'),
      title,
      numberLink,
      buttons,
      close
    );

    document.body.appendChild(dialog);

    var previousFocus = document.activeElement;

    close.addEventListener('click', function () {
      dialog.close();
    });

    dialog.addEventListener(
      'close',
      function () {
        dialog.remove();
        style.remove();

        if (numberFromHash(window.location.hash) === number) {
          window.history.replaceState(
            window.history.state,
            '',
            window.location.pathname + window.location.search
          );
        }

        if (previousFocus && previousFocus.isConnected) {
          previousFocus.focus();
        }
      },
      { once: true }
    );

    dialog.showModal();
  }

  function initialize(root) {
    if (controllers.has(root)) return;

    var modal = root.querySelector('[data-blano-inquiry-modal]');
    if (!modal) return;

    var abort = new AbortController();
    var signal = abort.signal;

    var overlay = root.querySelector('[data-blano-inquiry-overlay]');
    var form = root.querySelector('form');

    var phone = root.querySelector('#InquiryPhone');
    var phoneError = root.querySelector('#InquiryPhoneError');
    var phoneHelp = root.querySelector('#InquiryPhoneHelp');

    var select = root.querySelector('#InquiryCountry');
    var picker = root.querySelector('[data-country-picker]');
    var input = root.querySelector('[data-country-search]');
    var results = root.querySelector('[data-country-results]');
    var list = root.querySelector('[data-country-list]');
    var toggle = root.querySelector('[data-country-toggle]');
    var control = root.querySelector('[data-country-control]');
    var flag = root.querySelector('[data-country-flag]');
    var countryError = root.querySelector('#InquiryCountryError');
    var status = root.querySelector('[data-country-status]');
    var empty = root.querySelector('[data-country-empty]');

    var successOrErrors = root.querySelector(
      '[data-inquiry-success="true"], .blano-inquiry-errors'
    );

    var lastActiveElement = null;
    var focusTimer = null;
    var countries = [];
    var matches = [];
    var activeIndex = -1;
    var phoneTouched = false;

    var enhanced = Boolean(
      select && picker && input && results && list && toggle
    );

    var actionField = null;

    // Put Country before Phone.
    if (phone && select) {
      var phoneField = phone.closest('.blano-form-field');
      var countryField = select.closest('.blano-form-field');

      if (phoneField && countryField) {
        phoneField.before(countryField);
      }

      phone.placeholder = inquiryText('phone_placeholder_dynamic', '123 456 7891');

      if (form && phoneField) {
        actionField =
          form.querySelector('[name="contact[Call or text]"]') ||
          form.querySelector('[name="contact[Watch Link]"]');

        if (!actionField) {
          actionField = document.createElement('input');
          actionField.type = 'hidden';
          phoneField.after(actionField);
        }

        // One link opens the contact buttons over the relevant watch.
        actionField.name = 'contact[Call or text]';
        actionField.disabled = true;
      }
    }

    function listen(target, event, callback, options) {
      if (!target) return;

      target.addEventListener(
        event,
        callback,
        Object.assign({}, options, { signal: signal })
      );
    }

    function selectedCountry() {
      if (!select) return null;

      return (
        countries.find(function (country) {
          return country.value === select.value;
        }) || null
      );
    }

    function showError(field, target, message, visible) {
      field.setCustomValidity(message || '');

      if (visible && message) {
        field.setAttribute('aria-invalid', 'true');
      } else {
        field.removeAttribute('aria-invalid');
      }

      if (target) {
        target.textContent = visible ? message || '' : '';
        target.hidden = !(visible && message);
      }
    }

    function validatePhone(show, format) {
      if (!phone) return true;

      var selected = select && select.options[select.selectedIndex];
      var code = selected
        ? selected.getAttribute('data-country-code')
        : '';

      var checked = parsePhone(phone.value, code);

      showError(phone, phoneError, checked.error, show);

      if (!checked.error && format) {
        phone.value = checked.value;
      }

      if (actionField) {
        actionField.value = checked.error
          ? ''
          : contactActionURL(window.location.href, checked.dial);

        actionField.disabled = !actionField.value;
      }

      return !checked.error;
    }

    function refreshPhone() {
      var country = selectedCountry();
      var northAmerica =
        country && (country.code === 'CA' || country.code === 'US');

      if (phoneHelp) {
        phoneHelp.textContent = northAmerica
          ? inquiryText('phone_north_america_help', 'Enter 10 digits, optionally with 1 or +1. International numbers can use their own + calling code.')
          : inquiryText('phone_international_help', 'Include + and the country calling code for international numbers. Canada/US numbers can use 10 digits.');
      }

      if (phone) {
        phone.placeholder = inquiryText('phone_placeholder_dynamic', '123 456 7891');
      }

      if (phone && phone.value) {
        validatePhone(phoneTouched, false);
      }
    }

    function closeCountries() {
      if (!enhanced) return;

      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
    }

    function setActive(index) {
      activeIndex = index;

      Array.from(list.children).forEach(function (option, optionIndex) {
        option.classList.toggle('is-active', optionIndex === index);
      });

      var active = list.children[index];

      if (!active) {
        input.removeAttribute('aria-activedescendant');
        return;
      }

      input.setAttribute('aria-activedescendant', active.id);

      if (active.offsetTop < list.scrollTop) {
        list.scrollTop = active.offsetTop;
      } else if (
        active.offsetTop + active.offsetHeight >
        list.scrollTop + list.clientHeight
      ) {
        list.scrollTop =
          active.offsetTop + active.offsetHeight - list.clientHeight;
      }
    }

    function renderCountries(query) {
      matches = filterCountries(countries, query);

      var fragment = document.createDocumentFragment();

      matches.forEach(function (country, index) {
        var option = document.createElement('li');

        option.id = 'InquiryCountryOption-' + country.code;
        option.className = 'gml-country-option';
        option.setAttribute('role', 'option');
        option.setAttribute(
          'aria-selected',
          String(select.value === country.value)
        );

        option.dataset.countryIndex = String(index);


        var name = document.createElement('span');
        name.textContent = country.name;

        option.append(name);
        fragment.appendChild(option);
      });

      list.replaceChildren(fragment);

      empty.hidden = matches.length !== 0;

      var countryResultLabel = (matches.length === 1
        ? inquiryText('country_found', 'country found.')
        : inquiryText('countries_found', 'countries found.')).trim();
      status.textContent = matches.length + (countryResultLabel ? ' ' + countryResultLabel : '');

      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-expanded', 'true');

      list.scrollTop = 0;
      setActive(-1);
    }

    function chooseCountry(country) {
      if (!country) return;

      select.value = country.value;
      input.value = country.name;
      flag.textContent = country.flag;
      control.classList.add('has-selection');

      showError(input, countryError, '', false);
      closeCountries();

      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function validateCountry(show) {
      if (!enhanced) {
        return !select || select.checkValidity();
      }

      var normalized = normalizeCountry(input.value);
      var current = selectedCountry();

      if (!current || normalizeCountry(current.name) !== normalized) {
        var exact = countries.find(function (country) {
          return normalizeCountry(country.name) === normalized;
        });

        if (exact) {
          chooseCountry(exact);
        } else {
          select.value = '';
          flag.textContent = '';
          control.classList.remove('has-selection');
        }
      }

      var valid = Boolean(selectedCountry());

      showError(
        input,
        countryError,
        valid ? '' : inquiryText('country_required', 'Please select a country from the list.'),
        show
      );

      return valid;
    }

    function focusableElements() {
      return Array.from(
        modal.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]'
        )
      ).filter(function (element) {
        return (
          !element.disabled &&
          element.tabIndex >= 0 &&
          element.getClientRects().length > 0
        );
      });
    }

    function openModal(trigger) {
      if (!root.classList.contains('is-open')) {
        lastActiveElement = trigger || document.activeElement;
      }

      root.classList.add('is-open');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');

      if (overlay) overlay.classList.add('is-open');

      document.body.classList.add('blano-modal-open');

      window.clearTimeout(focusTimer);

      focusTimer = window.setTimeout(function () {
        var target =
          successOrErrors ||
          root.querySelector('#InquiryName') ||
          focusableElements()[0];

        if (target) {
          target.focus({ preventScroll: true });
        }
      }, 0);
    }

    function closeModal() {
      window.clearTimeout(focusTimer);
      closeCountries();

      root.classList.remove('is-open');
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');

      if (overlay) overlay.classList.remove('is-open');

      document.body.classList.remove('blano-modal-open');

      if (lastActiveElement && lastActiveElement.isConnected) {
        lastActiveElement.focus({ preventScroll: true });
      }
    }

    if (enhanced) {
      countries = Array.from(select.options)
        .filter(function (option) {
          return option.value;
        })
        .map(function (option) {
          var name =
            option.getAttribute('data-country-name') || option.value;

          var code = option.getAttribute('data-country-code');
          var label = countryLabels && code ? countryLabels.of(code) : name;
          option.textContent = label || name;

          return {
            name: label || name,
            code: code,
            value: option.value,
            flag: ''
          };
        });

      select.hidden = true;
      select.required = false;
      picker.hidden = false;
      input.disabled = false;

      root
        .querySelector('[data-country-label]')
        .setAttribute('for', input.id);

      var existing = selectedCountry();

      if (existing) chooseCountry(existing);

      listen(input, 'focus', function () {
        renderCountries(selectedCountry() ? '' : input.value);

        if (selectedCountry()) input.select();
      });

      listen(input, 'input', function () {
        select.value = '';
        flag.textContent = '';
        control.classList.remove('has-selection');

        showError(input, countryError, '', false);
        renderCountries(input.value);
      });

      listen(input, 'blur', function () {
        validateCountry(Boolean(input.value));
        closeCountries();
      });

      listen(toggle, 'mousedown', function (event) {
        event.preventDefault();
      });

      listen(toggle, 'click', function () {
        var wasOpen = !results.hidden;

        input.focus({ preventScroll: true });

        if (wasOpen) closeCountries();
        else renderCountries('');
      });

      listen(list, 'mousedown', function (event) {
        event.preventDefault();
      });

      listen(list, 'click', function (event) {
        var option = event.target.closest('[data-country-index]');

        if (option) {
          input.focus({ preventScroll: true });
          chooseCountry(matches[Number(option.dataset.countryIndex)]);
        }
      });

      listen(input, 'keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();

          if (results.hidden) {
            renderCountries(selectedCountry() ? '' : input.value);
          }

          if (matches.length) {
            var next =
              activeIndex < 0
                ? event.key === 'ArrowDown'
                  ? 0
                  : matches.length - 1
                : (activeIndex +
                    (event.key === 'ArrowDown' ? 1 : -1) +
                    matches.length) %
                  matches.length;

            setActive(next);
          }
        } else if (event.key === 'Enter' && !results.hidden) {
          event.preventDefault();

          if (activeIndex >= 0) {
            chooseCountry(matches[activeIndex]);
          } else if (matches.length === 1) {
            chooseCountry(matches[0]);
          } else {
            validateCountry(true);
          }
        } else if (event.key === 'Escape' && !results.hidden) {
          event.preventDefault();
          event.stopPropagation();
          closeCountries();
        }
      });

      listen(select, 'change', refreshPhone);
    }

    listen(phone, 'input', function () {
      validatePhone(phoneTouched, false);
    });

    listen(phone, 'blur', function () {
      phoneTouched = true;
      validatePhone(true, true);
    });

    if (form && phone && select) {
      form.noValidate = true;

      listen(
        form,
        'submit',
        function (event) {
          phoneTouched = true;

          validateCountry(true);
          validatePhone(true, true);

          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            form.reportValidity();
          }
        },
        { capture: true }
      );

      listen(form, 'formdata', function (event) {
        var option = select.options[select.selectedIndex];

        var checked = parsePhone(
          phone.value,
          option && option.getAttribute('data-country-code')
        );

        if (!checked.error) {
          event.formData.set('contact[phone]', checked.value);

          event.formData.set(
            'contact[Call or text]',
            contactActionURL(window.location.href, checked.dial)
          );
        } else {
          event.formData.delete('contact[Call or text]');
        }

        if (select.value) {
          event.formData.set('contact[Country]', select.value);
        }
      });
    }

    listen(document, 'click', function (event) {
      var trigger = event.target.closest('[data-blano-inquiry-open]');

      if (trigger) {
        event.preventDefault();
        openModal(trigger);
      }

      if (enhanced && !picker.contains(event.target)) {
        closeCountries();
      }
    });

    root
      .querySelectorAll('[data-blano-inquiry-close]')
      .forEach(function (button) {
        listen(button, 'click', closeModal);
      });

    listen(overlay, 'click', closeModal);

    listen(document, 'keydown', function (event) {
      if (
        !root.classList.contains('is-open') ||
        event.defaultPrevented
      ) {
        return;
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
      } else if (event.key === 'Tab') {
        var elements = focusableElements();
        var first = elements[0];
        var last = elements[elements.length - 1];

        if (
          event.shiftKey &&
          (document.activeElement === first ||
            !elements.includes(document.activeElement))
        ) {
          event.preventDefault();
          if (last) last.focus();
        } else if (
          !event.shiftKey &&
          (document.activeElement === last ||
            !elements.includes(document.activeElement))
        ) {
          event.preventDefault();
          if (first) first.focus();
        }
      }
    });

    controllers.set(root, function () {
      window.clearTimeout(focusTimer);

      if (root.classList.contains('is-open')) {
        document.body.classList.remove('blano-modal-open');
      }

      abort.abort();
    });

    refreshPhone();

    if (successOrErrors) openModal();
  }

  function initializeAll() {
    controllers.forEach(function (destroy, root) {
      if (!root.isConnected) {
        destroy();
        controllers.delete(root);
      }
    });

    document
      .querySelectorAll('[data-blano-inquiry-root]')
      .forEach(initialize);

    showContactActions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, {
      once: true
    });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
  window.addEventListener('hashchange', showContactActions);

  document.addEventListener('shopify:section:unload', function (event) {
    controllers.forEach(function (destroy, root) {
      if (event.target.contains(root)) {
        destroy();
        controllers.delete(root);
      }
    });
  });
})();
